import { name } from "file-loader";

const errorEmail = 'The field must contain a valid email address';

export default {
  actions: {
    search: 'Search',
    sendTokenAsign: 'Resend token to responsible party',
    selectSearch: 'Search editor',
    exactSearch: 'Exact search',
    optionsSearch: 'Filter type',
    selectedSearch: 'Selected fields',
    detail: 'Detail',
    delete: 'Delete',
    saveExit: 'Save and Exit',
    save: 'Save',
    add: 'Add',
    cancel: 'Cancel',
    confirm: 'Confirm',
    edit: 'Edit',
    editRoot: 'Edit root',
    request_update: 'Request change',
    activate: 'Activate',
    deactivate: 'Deactivate',
    select_one: 'Select...',
    moreActions: 'More actions',
    exportCSV: 'Export to CSV',
    exportXLSX: 'Export to XLSX',
    disable: 'Disable',
    enable: 'Enable',
    addOther: 'Add another',
    addLocation: 'Add location',
    exportPDF: 'Export to PDF',
    custodyVoucher: 'Custody voucher',
    exportPDFprice: 'Export to PDF with price',
    accept: 'Accept',
    reject: 'Reject',
    noDischarged: 'Not discharged',
    discharged: 'Discharged',
    all: 'All',
    noChangesToReview: 'No changes to review',
    changesToReview: 'Changes to review',
    qr_url: 'QR URL',
    qr_name: 'QR Name',
    qr_info: 'QR Info',
    barcode: 'Barcode',
    regenerateCodes: 'Regenerate codes',
  },
  common: {
    createdAt: 'Creation date',
    files: 'Click to select your files or drag them here',
    filesActive: 'Drop the files',
    filesLimits: (size, accepted) =>
      `Click to select your files or drag them here\nMax weight: ${size}\nSupported formats: ${accepted}`,
    file: 'Click to select the file or drag it here',
    fileActive: 'Drop the file',
    actions: 'Actions',
    error: 'Error',
    success: 'Success',
    status: 'Status',
    active_male: 'Active',
    active_female: 'Active',
    deactivated_male: 'Deactivated',
    deactivated_female: 'Deactivated',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading',
  },
  months: {
    1: 'Jan.',
    2: 'Feb.',
    3: 'Mar.',
    4: 'Apr.',
    5: 'May.',
    6: 'Jun.',
    7: 'Jul.',
    8: 'Aug.',
    9: 'Sep.',
    10: 'Oct.',
    11: 'Nov.',
    12: 'Dec.',
  },
  success: {
    custody_voucher_saved: 'The signed custody voucher was saved in the asset files.',
    employee_custody_voucher_saved:
      'The signed custody voucher was saved in the files of each of the custodian’s assets.',
    recover_password:
      'If you correctly entered your email address, we will send you instructions to recover your password.',
    reset_password: 'Your password was updated, you can now log in.',
    token_send: 'The asset assignment token has been successfully sent.',
    toggle_company: 'The company has been updated.',
    delete_company: 'The company has been deleted.',
    create_company: 'The company has been added.',
    edit_company: 'The company has been modified.',
    add_user: 'The user has been added',
    toggle_user: 'The user has been updated',
    update_user: 'The user has been updated',
    add_notification_config: 'The notification profile has been added',
    toggle_notification_config: 'The notification profile has been updated',
    update_notification_config: 'The notification profile has been updated',
    add_role: 'The role has been added',
    update_role: 'The role has been updated',
    complete_info: 'You have completed your information, you can now log in',
    create_subcompany: 'The company has been added.',
    edit_subcompany: 'The company has been modified.',
    toggle_subcompany: 'The company has been updated.',
    delete_subcompany: 'The company has been deleted.',
    add_asset: 'The asset has been added.',
    update_asset: 'The asset has been modified.',
    disable_asset: 'The asset has been disabled.',
    enable_asset: 'The asset has been recovered.',
    import_assets: 'Assets have been imported.',
    import: 'Data has been imported.',
    toggle_account: 'The record has been updated.',
    update_account: 'The record has been updated.',
    add_account: 'The record has been added.',
    toggle_depreciation: 'Depreciation has been updated.',
    update_depreciation: 'Depreciation has been updated.',
    add_depreciation: 'Depreciation has been added.',
    toggle_cost_centers: 'The cost center has been updated.',
    update_cost_centers: 'The cost center has been updated.',
    add_cost_centers: 'The cost center has been added.',
    toggle_inpc: 'INPC has been updated.',
    update_inpc: 'INPC has been updated.',
    add_inpc: 'INPC has been added.',
    toggle_custom_group: 'The group has been updated.',
    update_custom_group: 'The group has been updated.',
    add_custom_group: 'The group has been added.',
    toggle_exchange: 'The exchange rate has been updated.',
    update_exchange: 'The exchange rate has been updated.',
    add_exchange: 'The exchange rate has been added.',
    toggle_employee: 'The employee has been updated.',
    update_employee: 'The employee has been updated.',
    add_employee: 'The employee has been added.',
    update_catalogs: 'The catalog has been updated.',
    update_locations: 'Locations have been updated.',
    add_project: 'The project has been added.',
    update_project: 'The project has been updated.',
    toggle_project: 'The project has been updated.',
    toggle_providers_clients: 'The provider has been updated.',
    update_providers_clients: 'The provider has been updated.',
    add_providers_clients: 'The provider has been added',
    accept_historic: 'Changes have been accepted',
    reject_historic: 'Changes have been rejected',
    request_update_asset:
      'A record of the changes has been created, which must be approved for them to be reflected in the modified asset',
    asset_in: 'Asset entered',
    asset_out: 'Asset left',
    asset_needs_authorization: 'The exit request has been registered, awaiting authorization',
    asset_authorized_out: 'The asset exit has been authorized',
    asset_not_authorized_out: 'The asset exit has been rejected',
  },
  error: {
    subcompany_forbidden: 'You do not have access to this subcompany.',
    custody_voucher: {
      file_required: 'The voucher PDF was not received.',
      single_file: 'Send a single PDF.',
      too_large: 'The voucher PDF is larger than 10 MB.',
      bad_file_name: 'The voucher file name is not valid.',
      not_pdf: 'The voucher file is not a PDF.',
      no_custodian: 'The asset has no custodian.',
      bad_employee: 'The voucher custodian is missing.',
      bad_assets: 'The voucher asset list is not valid.',
      too_many_assets: 'The voucher covers too many assets (500 at most).',
      other_custodian: 'One of the assets has another custodian.',
      inactive_asset: 'One of the assets is inactive or disposed of.',
      incomplete:
        'Incomplete voucher: it must include all of the custodian’s assets. ' +
        'Clear the search and try again.',
      changed:
        'The assets changed while the voucher was being saved. Nothing was saved; try again.',
    },
    asset_not_found: 'The asset was not found.',
    employee_not_found: 'The custodian was not found.',
    cannot_upload: 'The file could not be uploaded, try again.',
    download_image: 'The image could not be downloaded, please try again',
    generate_pdf: 'The asset PDF could not be generated, please try again',
    session_expired: 'Your session has expired',
    session_terminated: 'You have logged in on another device',
    verify: 'Verify the fields',
    server_error: 'An error occurred while communicating with the server, please try again later',
    required: 'The field is required',
    format: 'The format is invalid',
    minLength: 'The field is required',
    type: 'The field is required',
    email: errorEmail,
    bad_credentials: 'The access data is not valid',
    bad_token: 'The token has expired or has already been used',
    company_not_found: 'The company is not found or is deactivated.',
    user_already_exists: 'A user with this email has already been added',
    add_duplicate_key: 'The key has already been used',
    asset_already_in: 'The asset is already inside',
    asset_already_out: 'The asset is already outside',
    asset_is_in: 'The asset is inside',
    asset_out_needs_message: 'A message is required for withdrawal',
    asset_needs_authorization: 'Authorization is required to proceed',
    asset_needs_asset_level: 'An asset level is required',
    asset_needs_employee: 'A responsible party is needed to withdraw',
    asset_can_not_withdraw: 'Cannot be withdrawn',
    asset: {
      limit_exceded: 'The limit of assets assigned to this company has been exceeded',
      files_limit_exceded: 'The file limit per asset has been exceeded.',
      size_limit_exceded: 'Check that the format and weight are supported.',
      dmsReference: {
        pattern: 'Must be between 8 and 10 characters long',
      },
    },
    login: {
      email: {
        format: errorEmail,
      },
      password: {
        required: 'The field must contain at least 12 characters',
        minLength: 'The field must contain at least 12 characters',
      },
    },
    users: {
      email: {
        format: errorEmail,
      },
      limit_exceded: 'The limit of administrators assigned to this company has been exceeded',
      admin_role_forbidden: 'Only the company administrator can assign or change the Administrator role.',
      subcompanies_forbidden: 'Only the company administrator can assign subcompanies.',
      subcompany_not_found: 'One of the chosen subcompanies no longer exists in the company.',
      subcompanies_not_saved: 'The server did not save the subcompanies. Check that the back end is up to date and try again.',
      root_not_editable: 'Root users are not edited from this screen: they see every subcompany.',
    },
    recover_password: {
      email: {
        format: errorEmail,
      },
    },
    reset_password: {
      password: {
        minLength: 'The password cannot be that short',
      },
    },
    depreciation_fails: 'Could not calculate:',
    user_password_expired:
      'Your password has expired, we have sent you an email to enter a new password.',
    asset_duplicated_number:
      'The number you are trying to save is already being used by another asset.',
  },
  info: {
    noResults: 'No results found',
  },
  login: {
    title: 'Login',
    subtitle: 'We are a company specialized in fixed asset control.',
    fields: {
      email: 'Email',
      password: 'Password',
      submit: 'Login',
      recovery: 'Forgot your password?',
    },
  },
  recover_password: {
    title: 'Recover password',
    subtitle: 'Enter the email address with which you are registered.',
    fields: {
      email: 'Email',
      submit: 'Send',
      login: 'Back to Login',
    },
  },
  reset_password: {
    title: 'New password',
    subtitle: 'Enter your new password.',
    fields: {
      password: 'Password',
      submit: 'Send',
      login: 'Back to Login',
    },
  },
  complete_info: {
    title: 'Complete registration',
    subtitle: 'To continue, complete the following information, then you can log in.',
    fields: {
      name: 'First name',
      lastname: 'Last name',
      password: 'Password',
      submit: 'Send',
      login: 'Back to Login',
    },
  },
  update_info: {
    title: 'Update information',
    subtitle: 'To continue, complete the following information, then you can log in.',
    fields: {
      name: 'First name',
      lastname: 'Last name',
      password: 'Password',
      submit: 'Send',
      login: 'Back to Login',
    },
  },
  acl: {
    companies: {
      edit: 'Edit Company Information',
    },
    users: {
      get: 'List and search Users',
      add: 'Add Users',
      update: 'Edit Users',
      toggle: 'Activate/Deactivate Users',
    },
    roles: {
      get: 'List and search Roles',
      add: 'Add Roles',
      update: 'Edit Roles',
      delete: 'Delete Roles',
      toggle: 'Activate/Deactivate Roles',
    },
    groups: {
      get: 'List and search Roles',
      add: 'Add Roles',
      update: 'Edit Roles',
      delete: 'Delete Roles',
      toggle: 'Activate/Deactivate Roles',
    },
    custom_employee_module: {
      get: 'List and search Employees',
      add: 'Add Employees',
      update: 'Edit Employees',
      delete: 'Delete Employees',
      toggle: 'Activate/Deactivate Employees',
    },
    custom_employee: {
      get: 'List and search custom fields',
      add: 'Add custom fields',
      update: 'Edit custom fields',
      delete: 'Delete custom fields',
      toggle: 'Activate/Deactivate custom fields',
    },
    custom_group: {
      get: 'List and search custom field groups',
      add: 'Add custom field groups',
      update: 'Edit custom field groups',
      delete: 'Delete custom field groups',
      toggle: 'Activate/Deactivate custom field groups',
    },
    asset_level: {
      get: 'List and search asset levels',
      add: 'Add asset levels',
      update: 'Edit asset levels',
      delete: 'Delete asset levels',
      toggle: 'Activate/Deactivate asset levels',
    },
    assetsFilters: {
      showFilters: 'Show Filters',
      hideFilters: 'Hide Filters',
    },
    assetsBills: {
      showForm: 'Add',
      hideForm: 'Hide',
      number: 'Number',
      folio: 'Folio',
      date: 'Date',
      import: 'Amount',
      concept: 'Concept',
      files: 'Files',
    },
    assetsCustomsDocuments: {
      showForm: 'Add',
      hideForm: 'Hide',
      pedimento_number: 'Pedimento number',
      customs_key: 'Customs key',
      date: 'Pedimento date',
      import: 'Amount',
      quantity: 'Quantity',
      pedimento_key: 'Pedimento key',
      files: 'Files',
      total_pedimentos: 'Total pedimentos',
      accumulated_import: 'Accumulated import',
      from: 'From',
      to: 'To',
      status: 'Status',
      save: 'Save',
      createdAt: 'Creation date',
    },
    insOuts: {
      in: 'Register asset entry',
      out: 'Request asset withdrawal',
    },
    notification_historic: {
      get: 'View notification history',
    },
    employees: {
      get: 'List and search Employees',
      add: 'Add Employees',
      update: 'Edit Employees',
      delete: 'Delete Employees',
      toggle: 'Activate/Deactivate Employees',
    },
    exchanges: {
      title: 'Exchange rates',
      get: 'List and search Exchange Rates',
      add: 'Add Exchange Rates',
      update: 'Edit Exchange Rates',
      delete: 'Delete Exchange Rates',
    },
    inpc: {
      title: 'INPC',
      get: 'List and search INPCs',
      add: 'Add INPCs',
      update: 'Edit INPCs',
      delete: 'Delete INPCs',
    },
    projects: {
      get: 'List and search Projects',
      add: 'Add Projects',
      update: 'Edit Projects',
      delete: 'Delete Projects',
      toggle: 'Activate/Deactivate Projects',
    },
    assets: {
      get: 'List and search Fixed Assets',
      add: 'Add Fixed Assets',
      update: 'Edit Fixed Assets',
      delete: 'Delete Fixed Assets',
      disable: 'Disable Fixed Assets',
      enable: 'Recover Disabled Fixed Assets',
      request_update: 'Request a change to an asset',
      review_request_update: 'Approve/Reject requested change to an asset',
    },
    cost_centers: {
      title: 'Cost Centers',
      get: 'List and search Cost Centers',
      add: 'Add Cost Centers',
      update: 'Edit Cost Centers',
      delete: 'Delete Cost Centers',
      toggle: 'Activate/Deactivate Cost Centers',
    },
    clients_providers: {
      get: 'List and search roles',
      add: 'Add roles',
      update: 'Edit roles',
      delete: 'Delete roles',
    },
    catalogs: {
      get: 'List and search Catalogs',
      update: 'Edit Catalogs',
    },
    subcompanies: {
      get: 'List and search Companies',
      add: 'Add Companies',
      update: 'Edit Companies',
      delete: 'Delete Companies',
      toggle: 'Activate/Deactivate Companies',
    },
    accounts: {
      get: 'List and search Accounts and Asset Types',
      add: 'Add Accounts and Asset Types',
      update: 'Edit Accounts and Asset Types',
      delete: 'Delete Accounts and Asset Types',
      toggle: 'Activate/Deactivate Asset Types',
    },
    depreciations: {
      get: 'List and search Depreciations',
      add: 'Add Depreciations',
      update: 'Edit Depreciations',
      delete: 'Delete Depreciations',
      toggle: 'Activate/Deactivate Depreciations',
    },
    providers_clients: {
      get: 'List and search Providers',
      add: 'Add Providers',
      update: 'Edit Providers',
      delete: 'Delete Providers',
      toggle: 'Activate/Deactivate Providers',
    },
    reports: {
      disabled: 'Consult the "Disabled Assets" report',
      depreciation: 'Consult the "Depreciation by Fixed Asset" report',
      employees_assets: 'Custody Vouchers',
      historics: 'Asset History',
      ins_outs: 'Entries and Exits',
    },
    import: {
      import: 'Allows importing assets through a CSV file',
    },
    locations: {
      get: 'List locations',
      update: 'Update locations',
    },
    mantenimiento_module: {
      get: 'List and search assets in maintenance',
    },
    mantenimiento: {
      get: 'List and search assets in maintenance',
      add: 'Add to maintenance',
      update: 'Edit maintenance',
      toggle: 'Activate/Deactivate Maintenance',
    },
    notifications_config: {
      get: 'List and search notification configurations',
      add: 'Add to notification configuration',
      update: 'Edit notification profile',
      toggle: 'Activate/Deactivate Notification Profile',
    },
    notification_historic: {
      get: 'List and search notifications',
    },
    asset_level: {
      get: 'List and search asset levels',
      add: 'Add to asset level',
      update: 'Edit asset level',
      delete: 'Delete asset level',
      toggle: 'Activate/Deactivate asset level',
    },
    ins_outs: {
      in: 'Register asset entry',
      out: 'Request asset withdrawal',
      resolve: 'Resolve asset withdrawal',
    },
    custom_employee: {
      get: 'List and search custom fields',
      add: 'Add to custom fields',
      update: 'Edit custom fields',
      delete: 'Delete custom fields',
      toggle: 'Activate/Deactivate custom fields',
    },
    custom_group: {
      get: 'List and search custom field groups',
      add: 'Add to custom field groups',
      update: 'Edit custom field groups',
      delete: 'Delete custom field groups',
      toggle: 'Activate/Deactivate custom field groups',
    },
  },
  ins_outs: { title: 'Entries and Exits' },
  companies: {
    title: 'Companies',
    form_edit_title: 'Edit company',
    form_add_title: 'Add company',
    permissions: 'Role',
    delete_title: 'Delete company',
    typeService: 'Tipo de servicio',
    delete_confirm:
      'Are you sure you want to delete the company <strong>{{name}}</strong>? * <br/><br/> <small>* This action cannot be undone.</small>',
    fields: {
      name: 'Name',
      shortname: 'Short name',
      adminsLimit: 'Number of Admin users per Company',
      assetsLimit: 'Number of Assets per Company',
      sizePerFile: 'File Size per Asset, in MB',
      filesPerAsset: 'Number of Files per Asset',
      initDate: 'Start Date',
      endDate: 'End Date',
      salesAgentName: 'Sales Agent Name',
      salesAgentEmail: 'Sales Agent Email',
      isDemo: 'Demo Company',
    },
  },
  subcompanies: {
    none_assigned: 'You have no subcompanies assigned',
    title: 'Companies',
    form_edit_title: 'Edit company',
    form_add_title: 'Add company',
    delete_title: 'Delete company',
    delete_confirm:
      'Are you sure you want to delete the company <strong>{{name}}</strong>? * <br/><br/> <small>* This action cannot be undone.</small>',
    fields: {
      name: 'Name',
      shortname: 'Short name',
    },
  },
  users: {
    title: 'Users',
    subtitle: 'Users',
    usersNotify: 'USERS TO NOTIFY',
    form_edit_title: 'Edit user',
    form_add_title: 'Add user',
    fields: {
      name: 'First name',
      lastname: 'Last name',
      email: 'Email',
      roleId: 'Role',
      subcompanies: 'Subcompanies',
      all_subcompanies: 'All',
      root_all_subcompanies: 'Root user: sees every subcompany.',
    },
    searchEditor: {
      name: 'First name',
      lastName: 'Last name',
      email: 'Email',
    },
  },
  roles: {
    title: 'Roles',
    subtitle: 'Roles',
    form_edit_title: 'Edit role',
    form_add_title: 'Add role',
    fields: {
      name: 'Name',
      permissions: 'Permissions',
      default: 'Default',
    },
    permissions: {
      key: 'Key',
      description: 'Description',
    },
    searchEditor: {
      name: 'Name',
    },
  },
  groups: {
    title: 'Groups',
    subtitle: 'Groups',
    form_edit_title: 'Edit group',
    form_add_title: 'Add group',
    fields: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
      module: 'Module',
      active: 'Active',
      customs: 'Custom Fields',
    },
    permissions: {
      key: 'Key',
      description: 'Description',
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
      module: 'Module',
    },
    moduleDropDown: {
      employees: 'Employees',
      centerCost: 'Cost Center',
      providers: 'Providers',
      projects: 'Projects',
      typeAssets: 'Asset Type',
      contableAccounts: 'contable_accounts',
      depreciations: 'Depreciations',
      assets: 'Assets',
    },
  },
  pagination: {
    prev: '<',
    next: '>',
    show: 'Showing',
    of: 'of',
    per_page: 'per page',
  },
  assets: {
    title: 'Fixed Assets',
    subtitle: 'Fixed Assets',
    add: 'Add fixed asset',
    edit: 'Edit fixed asset',
    detail: 'Fixed asset detail',
    disable: 'Disable fixed asset',
    depreciation: 'Accumulated Depreciation',
    depreciationPercentage: '% Accumulated Depreciation',
    depreciation_financial: 'Financial Depreciation',
    depreciation_fiscal: 'Fiscal Depreciation',
    depreciation_info: 'Asset information',
    depreciation_values: 'Depreciation calculation',
    depreciable: 'Depreciable value',
    enable_title: 'Recover fixed asset',
    enable_confirm:
      'Are you sure you want to recover the asset <strong>"{{number}} - {{name}}"</strong> that had been disabled? * <br/><br/> <small>* This action cannot be undone.</small>',
    subtitle_monts_and_records_assets: "Sum of amounts and assets",
    amount_and_assets_per_page: "Amount and assets per page",
    amount_and_record_of_all_assets: "Amount and record of all assets",
    totalMoney: 'Total amount',
    totalCount: 'Total assets',
    section: {
      disable: 'Disabling detail',
      accountant: 'Accountant',
      assurance: 'Insurance',
      in_out: 'Entries and Exits',
      bill: 'Invoice',
      bills: 'Invoices',
      customs_documents: 'Customs information',
      customs_documents_title: 'Import Pediments',
      buy: 'Purchase',
      customFields: 'Custom fields',
      general: 'General',
      location: 'Location',
      project: 'Project',
      files: 'Files',
      form: 'Data',
      depreciation: 'Depreciation',
      notes: 'Notes',
      historic: 'History',
      codes: 'Codes',
      downloadQR: 'Download QR',
      downloadBarcode: 'Download barcode',
      regenerateCode: 'Regenerate codes',
      codes: {
        title_qrUrl: "QR code with asset's URL",
        title_qrName: "QR code with asset's name",
        title_qrData: "QR code with asset's data",
        title_barcode: "Barcode with asset's number",
        codeLabel: 'Download code',
        fields_data_asset: {
          name: 'Name',
          number: 'Number',
          brand: 'Brand',
          model: 'Model',
          serie: 'Serial number',
          employee: 'Responsible',
          location: 'Location',
          createdAt: 'Creation date',
          updatedAt: 'Last update',
        },
        info: {
          qrUrl:
            'This QR code contains the shortened URL of the asset, redirecting to the SAAF system.',
          qrName: 'This QR code is composed of the account, subaccount, and number of the asset.',
          qrData: 'This QR code contains the following asset information in plain text:',
          barcode: 'This barcode is composed of the account, subaccount, and number of the asset.',
        },
        format: {
          codeLabel: 'Code label',
          pdf: 'PDF',
          docx: 'DOCX',
          png: 'PNG',
          png_qr: 'PNG QR',
          png_barcode: 'PNG barcode',
        },
      },
    },
    fields: {
      bills: 'Invoices',
      files: 'Files',
      consecutive: 'Consecutive',
      asset_level: 'Asset Level',
      level: 'Asset Level',
      account: 'Account(Name)',
      accountKey: 'Account(Key)',
      billConcept: 'Invoice concept',
      billDate: 'Invoice date',
      billFolio: 'Invoice folio',
      billNumber: 'Invoice number',
      billImport: 'Invoice amount',
      dmsReference: 'DMS reference',
      custodyNotes: 'Custody voucher notes',
      custodyNotesHelp: 'One line per item delivered with the asset (registration card, keys, accessories…)',
      customs_documents_pedimento_number: 'Pedimento number',
      customs_documents_customs_key: 'Customs key',
      customs_documents_date: 'Pedimento date',
      customs_documents_pedimento_key: 'Pedimento key',
      customs_documents_import: 'Pedimento amount',
      customs_documents_quantity: 'Quantity',
      customs_documents_upload_files: 'Upload file',
      brand: 'Brand',
      buyCondition: 'Purchase condition',
      buyDate: 'Purchase date',
      buyOrder: 'Purchase order',
      approvalNumber: 'Approval No.',
      createdAt: 'Creation date',
      coin: 'Currency',
      costCenter: 'Cost center',
      country: 'Country',
      description: 'Description',
      dollarAssetPrice: 'Purchase price of the asset in dollars',
      insurable: 'Insurable',
      insuranceCarrier: 'Insurance company',
      insurancePercent: 'Insured percentage',
      insurancePolicy: 'Insurance policy',
      financialDepreciation: 'Financial depreciation',
      fiscalDepreciation: 'Fiscal depreciation',
      usefulLifeOriginal: 'Useful life original',
      location: 'Location',
      life: 'Use time (years)',
      model: 'Model',
      name: 'Name',
      number: 'Number',
      physicalState: 'Physical state',
      prefix: 'Prefix',
      price: 'Price',
      priceDollars: 'Price in dollars',
      currentMonthDep: 'Depreciation months current period',
      totalMonthYearsDep: 'Depreciation months in previous years',
      totalMonthYearsDepAct: 'Depreciation months in current year',
      totalMonthLife: 'Total months to be depreciated',
      monthlyDepDollars: 'Monthly depreciation USD',
      monthlyDep: 'Monthly depreciation',
      moi: 'M.O.I (recalculated)',
      exchange: 'Exchange rate',
      project: 'Project',
      projectPrice: 'Project cost',
      provider: 'Provider',
      serie: 'Serial number',
      startDate: 'Start date',
      status: 'Status',
      subaccount: 'Type',
      sublocation: 'Location level',
      asignedEmployeeDate: 'Assigned responsible date',
      employee: 'Responsible',
      validated: 'Responsible status',
      validatedDate: 'Responsible validation date',
      depreciationName: 'Applied depreciation',
      remainingLife: 'Remaining life',
      endDate: 'Value date',
      lifeTime: 'Useful life (years)',
      currentDepreciation: 'Current period depreciation',
      lastDepreciation: 'Previous period depreciation',
      inpcStart: 'INPC acquisition',
      inpcEnd: 'INPC use',
      factor: 'Update factor',
      lastDepreciationRecalculated: 'Recalculated current period depreciation',
      totalDepreciation: 'Total depreciation',
      depreciable: 'Net replacement value',
      img_asset: 'Asset',
      img_employee: 'Employee',
      notes: {
        text: 'Note',
        createdBy: 'Created by',
        createdAt: 'Creation date',
        notSaved: 'Pending',
        empty: 'No notes have been added yet',
      },
      historics: {
        field: 'Field',
        after: 'New value',
        before: 'Previous value',
        hide: 'Hide changes',
        show: 'Show changes',
        date: 'Date',
        user: 'User',
        status: 'Status',
        empty: 'No changes have been registered yet',
        statusName: {
          ACCEPTED: 'Accepted',
          REJECTED: 'Rejected',
          PENDING: 'Pending',
        },
        buttonFilters: {
          showFilters: 'Show Filters',
          hideFilters: 'Hide Filters',
        },
        searchEditor: {
          billNumber: 'Invoice number',
          billFolio: 'Invoice folio',
          billConcept: 'Invoice concept',
          consecutive: 'Consecutive',
          prefix: 'Prefix',
          number: 'Number',
          name: 'Name',
          description: 'Description',
          account: 'Account',
          subAccount: 'Type',
          costCenter: 'Cost center',
          employee: 'Employee',
          provider: 'Provider',
          buyOrder: 'Purchase order',
          serie: 'Series',
          file: 'File',
          customs_documents_pedimento_number: 'Pedimento number',
          customs_documents_customs_key: 'Customs key',
          customs_documents_pedimento_key: 'Pedimento key',
        },
      },
      out: {
        get_in: 'Asset entry',
        get_out: 'Asset exit',
        createdAt: 'Date',
        outDate: 'Exit date',
        time_out: 'Days out',
        isOut: 'Status',
        is_in: 'Inside',
        is_out: 'Outside',
        message: 'Message',
        acept_output: 'Accept Exit',
        reject_output: 'Reject Exit',
        _user_request: 'Requested by',
        _user_authorized: 'Authorized by',
        role_to_acept: 'Authorization (Role)',
        needs_authorization: 'Awaiting authorization',
        message_required: 'Awaiting authorization',
        out: 'Exit',
        in: 'Entry',
        'reject out': 'Exit rejection',
        'acept out': 'Exit acceptance',
        'out request': 'Exit request',
        status: 'Status',
        _employee: 'Responsible',
      },
      disabled: 'Disabled',
      disableReason: 'Disable reason',
      disableDetail: 'Detail',
      disableAmount: 'Recovered amount',
      disableDate: 'Disable date',
      refound: 'Loss/Gain',
      hasPendingChanges: 'Changes to review',
      _group: 'Custom Groups',
      _extraDepreciations: 'Additional depreciations',
      _customsDocuments: 'Import customs documents',
    },
    searchEditor: {
      assets: 'Assets',
      id: 'ID',
      number: 'Number',
      name: 'Name',
      description: 'Description',
      accountType: 'Account',
      assetType: 'Asset type',
      centerCost: 'Cost center',
      nameEmployee: 'Employee first name',
      lastNameEmployee: 'Employee last name',
      provider: 'Provider',
    },
    oldSearchEditor: {
      oldValues: 'Old values',
      id: 'ID',
      number: 'Number',
      name: 'Name',
      description: 'Description',
      contableAccount: 'Account',
      assetType: 'Asset type',
      centerCost: 'Cost center',
      nameEmployee: 'Employee first name',
      lastNameEmployee: 'Employee last name',
      provider: 'Provider',
    },
    changeSearchEditor: {
      changes: 'Changes',
      value: 'Values',
    },
    tablesDepreciationColums: {
      year: 'Year',
      period: 'Period',
      monthsDepExercise: '#Dep. months in the exercise',
      totalMonthsDepExercise: 'Total dep. months in exercises',
      totalMonthsToDep: 'Total months to be depreciated',
      factor: 'Factor',
      depMonthly: 'Monthly dep.',
      depPeriod: 'Dep. Period',
      percentajeDepPeriod: '% Dep. Period',
      depAccumulated: 'Accumulated dep.',
      percentajeDepAccumulated: '% Accumulated dep.',
      valueToDepreciate: 'Value to be depreciated',
    },
  },
  menu: {
    dashboard: 'Dashboard',
    asset_level: 'Asset level',
    control_panel: 'Control panel',
    configuration: 'Configuration',
    users: 'Users',
    notifications_config: 'Notifications',
    notifications_historic: 'Notifications',
    roles: 'Roles',
    groups: 'Custom Groups',
    subcompanies: 'Manage Companies',
    subcompanies_add: 'Add a Company',
    assets: 'Assets',
    maintenance: 'Maintenance',
    reports: 'Reports',
    reports_depreciation: 'Depreciation',
    reports_disabled: 'Disabled',
    reports_historics: 'History',
    import: 'Import',
    custom_fields_employees: 'Custom Fields',
    employees: 'Employees',
    accounts: 'Accounts',
    subaccounts: 'Asset types',
    depreciations: 'Depreciations',
    costCenters: 'Cost centers',
    catalogs: 'Catalogs',
    inpc: 'INPC',
    exchange: 'Exchange rate',
    locations: 'Locations',
    projects: 'Projects',
    providers: 'Providers',
    actions: {
      logout: 'Logout',
      update: 'Edit my information',
      edit: '',
    },
    reports_employees_assets: 'Custody Vouchers',
    reports_ins_outs: 'Entries and Exits',
    support: 'Help and Support',
    maintenance: 'Maintenance Alfa',
  },
  catalog: {
    physicalState: {
      name: 'Physical State',
      elements: {
        excelent: 'Excellent',
        good: 'Good',
        medium: 'Fair',
        bad: 'Bad',
      },
    },
    country: {
      name: 'Country',
      elements: {
        mex: 'Mexico',
        usa: 'United States of America',
      },
    },
    coin: {
      name: 'Currency',
      elements: {
        mxn: 'Mexican Pesos',
        usd: 'United States Dollars',
        eur: 'Euros',
      },
    },
    buyCondition: {
      name: 'Purchase Condition',
      elements: {
        new: 'New',
        used: 'Used',
      },
    },
    status: {
      name: 'Status',
      elements: {
        depreciating: 'Depreciating',
        not_depreciating: 'Not depreciating',
        in_construction: 'Under construction',
      },
    },
    disableReason: {
      name: 'Disable reason',
      elements: {
        sell: 'Sell',
        damage: 'Damage',
      },
    },
    prefix: {
      name: 'Prefix',
    },
    depreciationCriteria: {
      name: 'Depreciation Criteria',
      elements: {
        date: 'Application date',
        month: 'Next month',
      },
    },
    insuranceCarrier: {
      name: 'Insurance company',
    },
    customs_documents_status: {
      name: 'Pedimento status',
      elements: {
        temporary_importation: 'Temporary importation',
        definitive_importation: 'Definitive importation',
        returned: 'Returned',
        virtual: 'Virtual',
      },
    },
  },
  dashboard: {
    title: 'Dashboard',
    showAssets: 'VIEW',
    addAsset: 'ADD ASSET',
    assetsTotal: 'Number of assets',
    amountTotal: 'Total amount',
    totalByAccounts: 'Assets by account',
    totalByCostCenters: 'Assets by cost center',
    amountByCostCenters: 'Asset cost by cost center',
    totalByStatus: 'Assets by status',
  },
  custom_employee_module: {
    title: 'Custom Fields',
  },
  custom_employee: {
    title: 'Custom Fields',
  },
  custom_group: {
    title: 'Custom Field Groups',
  },
  custom_fields: {
    title: 'Custom Fields',
  },
  custom_field: {
    title: 'Custom Fields - Fields',
    empty: 'Empty',
  },
  custom_fields_employees: {
    title: 'Custom Fields',
    employees_title: 'Custom Fields',
    edit: 'Edit Custom Field',
    add: 'Add Custom Field',
    fields: {
      key: 'Key',
      name: 'Name',
      active: 'Active',
      type: 'Type',
      description: 'Description',
    },
    add: {
      numeric: 'Numeric',
      coin: 'Currency',
      date: 'Date',
      shortText: 'Short text',
      largeText: 'Long text',
      dropDown: 'Dropdown',
      uniqueSelection: 'Single selection',
      multipleSelection: 'Multiple selection',
      hour: 'Hour',
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
      type: 'Type',
    },
  },
  notifications_config: {
    title: 'Notification Configuration',
  },
  notification_config: {
    title: 'Notification Configuration',
    edit: 'Edit notification profile',
    add: 'Add notification profile',
    description: 'Description',
    key: 'Code',
    fields: {
      key: 'Key',
      name: 'Name',
      send_mail: 'Send Email',
      destinatarios: '# Recipients',
      options: '# Options',
      active: 'Active',
      type: 'Type',
      description: 'Description',
    },
    form: {
      general: 'General Data',
      customFields: 'Notifications',
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
    },
  },
  notify: {
    assets: {
      add: 'Add asset',
      disable: 'Disable an asset',
      edit: 'Edit an asset',
      edit_request: 'Request asset edit',
      edit_create_historic: 'Create change history',
      edit_accept: 'Accept asset edit',
      edit_reject: 'Reject asset edit',
      restore: 'Recover asset',
      out: 'Asset exit',
      in: 'Asset entry',
      reject_out: 'Asset exit rejection',
      accept_out: 'Asset exit accepted',
      out_request: 'Asset exit request',
    },
  },
  notification_historic: {
    title: 'Notifications',
    edit: 'Edit notification profile',
    add: 'Add notification profile',
    view_email: 'View Email',
    fields: {
      key: 'Key',
      subject: 'Subject',
      name: 'Code',
      send_mail: 'Send Email',
      destinatarios: '# Recipients',
      options: '# Options',
      active: 'Active',
      date: 'Date',
      type: 'Type',
      description: 'Description',
    },
    searchEditor: {
      name: 'Code',
      subject: 'Subject',
      destinatarios: '# Recipients',
    },
  },
  employees: {
    title: 'Employees',
    employees_title: 'Employees',
    edit: 'Edit employee',
    add: 'Add employee',
    fields: {
      key: 'Key',
      name: 'First name',
      lastname: 'Last name',
      email: 'Email',
      position: 'Position',
      numberAssignedAssets: '# Assigned assets',
      active: 'Active',
      group: 'Custom field group',
    },
    searchEditor: {
      key: 'Key',
      name: 'First name',
      lastname: 'Last name',
      email: 'Email',
      position: 'Position',
    },
  },
  custodyVoucher: {
    signature: 'Custodian signature',
    signatureHelp: 'Sign with your finger, a pen or the mouse.',
    clear: 'Clear signature',
    downloadForPaper: 'Download to sign on paper',
    signAndSave: 'Sign and save',
    withoutPrice: 'Without price',
    withPrice: 'With price',
    custodian: 'Custodian',
    assets: 'Assets covered',
    reviewHint: 'To review the whole document, download it to sign on paper.',
    signFromActions: 'Sign custody voucher',
    signGeneral: 'Sign and save',
    newCustodianNotice:
      'The asset has a new custodian. Generate their voucher in the detail: ' +
      'Actions > Sign custody voucher.',
    clearSearchToSign: 'Clear the search to sign the voucher with all the assets.',
  },

  files: {
    locked: 'Signed',
    voucherCurrent: 'Current',
    voucherPrevious: 'Previous',
    signedFor: 'Custodian',
    custodianUnknown: 'not recorded',
    signedAt: 'Signed on',
    preview: 'Preview',
    name: 'Name',
    default: 'Default',
    actions: 'Actions',
    status: 'Status',
    empty: 'No files have been added yet',
    pending: 'To be loaded...',
    uploading: 'Uploading...',
    uploaded: 'Uploaded',
    fail: 'Failed',
    importing: 'Importing data...',
    imported: 'Data imported',
  },
  reports: {
    title: 'Reports',
    fields: {
      accounts: 'Accounts',
      subaccounts: 'Types',
      costCenters: 'Cost centers',
      employees: 'Employees',
      providers: 'Providers',
      projects: 'Projects',
      depreciationType: 'Depreciation type',
      endDate: 'Value date',
      status: 'Status',
      disabled: 'Disabled',
      physicalState: 'Physical state',
      hasPendingChanges: 'Changes to review',
      createdAt: 'Request date',
      reviewDate: 'Review date',
      buttonFilters: {
        showFilters: 'Show Filters',
        hideFilters: 'Hide Filters',
      },
    },
    values: {
      depreciationType: {
        fiscal: 'Fiscal',
        financial: 'Financial',
      },
    },
    depreciation: {
      title: 'Depreciation report by asset',
      subtitle: 'Depreciation report by asset',
    },
    disabled: {
      title: 'Disabled assets report',
      subtitle: 'Disabled assets report',
    },
    ins_outs: {
      title: 'Entries and exits report',
      subtitle: 'Entries and exits report',
    },
    employeesAssets: {
      hideAssets: 'Hide assigned assets',
      showAssets: 'Show assigned assets',
      assigned: 'Assigned assets',
      title: 'Custody Vouchers',
      subtitle: 'Custody Vouchers',
    },
    historics: {
      hideAssets: 'Hide changes',
      showAssets: 'Show changes',
      assigned: 'Assigned assets',
      title: 'Asset Change History',
      subtitle: 'Asset Change History',
      fields: {
        status: 'Status',
        createdAt: 'Request',
        reviewDate: 'Reviewed',
        createdBy: 'Request',
        reviewedBy: 'Reviewed',
        key: 'Key',
        number: 'Number',
        location: 'Location',
        name: 'Asset',
        account: 'Account',
        sub_account: 'Asset type',
        costCenter: 'Cost center',
        assigned: 'Responsible',
        assigned_status: 'Responsible',
      },
    },
    searchEditor: {
      assets: 'Assets',
      id: 'ID',
      number: 'Number',
      name: 'Name',
      description: 'Description',
      accountType: 'Account type',
      assetType: 'Asset type',
      centerCost: 'Cost center',
      nameEmployee: 'Employee first name',
      lastNameEmployee: 'Employee last name',
      provider: 'Provider',
    },
    oldSearchEditor: {
      oldValues: 'Old values',
      id: 'ID',
      number: 'Number',
      name: 'Name',
      description: 'Description',
      contableAccount: 'Account',
      assetType: 'Asset type',
      centerCost: 'Cost center',
      nameEmployee: 'Employee first name',
      lastNameEmployee: 'Employee last name',
      provider: 'Provider',
    },
    changeSearchEditor: {
      changes: 'Changes',
      field: 'Field',
      value: 'Value',
    },
  },
  import: {
    title: 'Import Module',
    unassigned: 'unassigned',
    list_subtitle: 'Import Module',
    form_subtitle: 'Import data from a file',
    reimport_title: 'Re-Import',
    reimport:
      "Re-import to the module: '<strong>{{name}}</strong>'? * <br /><br /> <small>* This action cannot be undone.</small>",
    error: {
      verify: 'Select a file to import it',
      fileType: 'Error selecting file, only csv files are allowed.',
      importing:
        'An error occurred while trying to import the file, the file may be damaged or not have the correct format',
    },
    modules: {
      assets: 'Assets',
      providers: 'Providers',
      projects: 'Projects',
      cost_centers: 'Cost centers',
      cuenta_contable: 'Accounts',
      tipo_activo: 'Asset types',
      custom_employees: 'Employee custom fields',
      employees: 'Employees',
      locations: 'Locations',
    },
    fields: {
      files: 'File',
      module: 'Module',
      createdAt: 'Import date',
      status: 'Status',
      updated: '# Updated records',
      inserted: '# Created records',
      fail: '# Failed records',
      warnings: '# Warnings',
      import: 'Re-import',
      selectHeaders: 'Select Headers',
      actions: 'Actions',
      file: 'File',
      download: 'Download CSV',
      csvTemplateAssets: 'Assets CSV Template',
    },
    showDetailsFields: {
      showDetails: 'Show details',
      hideDetails: 'Hide details',
      new: 'New',
      success: 'Success',
      warning: 'Warnings',
      wrongs: 'Errors',
    },
    searchEditor: {
      assets: 'Assets',
      provider: 'Providers',
      projects: 'Projects',
      costCenter: 'Cost centers',
      ledgerAccounts: 'Accounts',
      typeAssets: 'Asset types',
      customFieldsEmployees: 'Employee custom fields',
      employees: 'Employees',
      locations: 'Locations',
    },
  },
  exchanges: {
    title: 'Exchange rates',
  },
  exchange: {
    title: 'Exchange rates',
    exchange_title: 'Exchange rates',
    edit: 'Edit Exchange rate',
    add: 'Add Exchange rate',
    fields: {
      fromCurrency: 'Source Currency',
      toCurrency: 'Target Currency',
      value: 'Value',
      date: 'Date',
    },
  },
  cost_centers: {
    title: 'Cost centers',
  },
  costCenters: {
    title: 'Cost centers',
    costCenters_title: 'Cost centers',
    edit: 'Edit Cost center',
    add: 'Add Cost center',
    fields: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
      active: 'Active',
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
    },
  },
  providers_clients: {
    title: 'Providers',
  },
  catalogs: {
    title: 'Catalogs',
    catalogs_title: 'Catalogs',
    edit: 'Edit catalog',
    form: {
      general: 'General data',
      elements: 'Catalog elements',
    },
    fields: {
      key: 'Key',
      name: 'Name',
      value: 'Value',
      elements: 'Elements',
      active: 'Active',
    },
    searchEditor: {
      key: 'Key',
    },
  },
  accounts: {
    title: 'Accounts and Asset Types',
    accounts_title: 'Accounts',
    edit: 'Edit Account',
    add: 'Add Account',
    form: {
      general: 'General data',
      depreciations: 'Depreciation',
      customFields: 'Custom fields',
    },
    fields: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
      active: 'Active',
      fiscalDepreciation: 'Fiscal Depreciation',
      financialDepreciation: 'Financial Depreciation',
      customFields: {
        key: 'Key',
        label: 'Label',
        unique: 'Unique Field',
        dependent: 'Dependent Value',
      },
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
    },
  },
  subaccounts: {
    subaccounts_title: 'Asset types',
    edit: 'Edit Asset type',
    add: 'Add Asset type',
    form: {
      general: 'General data',
      depreciations: 'Depreciation',
      customFields: 'Custom fields',
    },
    fields: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
      active: 'Active',
      parent: 'Account',
      fiscalDepreciation: 'Fiscal Depreciation',
      financialDepreciation: 'Financial Depreciation',
      customFields: {
        key: 'Key',
        label: 'Label',
      },
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
      description: 'Description',
      parent: 'Account',
    },
  },
  depreciations: {
    title: 'Depreciations',
    depreciations_title: 'Depreciations',
    edit: 'Edit Depreciation',
    add: 'Add Depreciation',
    form: {
      general: 'General data',
      percents: 'Depreciation percentages',
    },
    fields: {
      key: 'Key',
      name: 'Name',
      active: 'Active',
      maximumAmount: 'Maximum amount to be depreciated',
      maximumPercent: 'Maximum percentage to be depreciated',
      criteria: 'Criteria',
      year: 'Year',
      percentage: 'Percentage',
      total: 'Total',
      monthslastyear: 'Months in the last year',
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
    },
  },
  inpc: {
    inpc_title: 'National Consumer Price Index',
    title: 'INPC',
    edit: 'Edit INPC',
    add: 'Add INPC',
    form: {
      general: 'General data',
      percents: 'Depreciation percentages',
    },
    fields: {
      key: 'Key',
      name: 'Name',
      active: 'Active',
      maximumAmount: 'Maximum depreciable amount',
      criteria: 'Criteria',
      year: 'Year',
      percentage: 'Percentage',
      total: 'Total',
    },
    searchEditor: {
      year: 'Year',
    },
  },
  locations: {
    title: 'Locations',
    locations_title: 'Locations',
  },
  projects: {
    fields: {
      key: 'Key',
      name: 'Name',
      amount: 'Amount',
      active: 'Active',
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
      amount: 'Amount',
      active: 'Active',
    },
    title: 'Projects',
    edit: 'Edit project',
    add: 'Add project',
  },
  asset_level: {
    fields: {
      key: 'Key',
      name: 'Name',
      max_time: 'Max days out',
      message_required: 'Message required',
      can_withdrawn: 'Can be withdrawn',
      role_to_acept: 'Requires acceptance from',
      active: 'Active',
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
      amount: 'Amount',
    },
    title: 'Asset Level',
    edit: 'Edit asset level',
    add: 'Add asset level',
  },
  ins_outs: {
    title: 'Entries and Exits',
  },
  providers: {
    fields: {
      key: 'Key',
      name: 'Name',
      mail: 'Email',
      telephone: 'Phone',
      rfc: 'RFC',
      active: 'Active',
    },
    searchEditor: {
      key: 'Key',
      name: 'Name',
      mail: 'Email',
      telephone: 'Phone',
      rfc: 'RFC',
    },
    title: 'Providers',
    edit: 'Edit provider',
    add: 'Add provider',
  },
  mantenimiento: {
    title: 'Maintenance',
  },
  mantenimiento_module: {
    title: 'Maintenance Module (Extra)',
    edit: 'Edit',
    add: 'Add to maintenance',
    fields: {
      key: 'Key',
      name: 'Name',
      mail: 'Email',
      telephone: 'Phone',
      rfc: 'RFC',
      active: 'Active',
    },
  },
  asset_employeePDF: {
    title: 'Custody Voucher',
    date: 'Date',
    employee: 'Employee',
    position: 'Position',
    id: 'Employee key',
    table: {
      number: 'Number',
      name: 'Name',
      brand: 'Brand',
      model: 'Model',
      serie: 'Serial Number',
    },
    message: {
      title: 'I received the equipment mentioned below:',
      content:
        'Which I promise to take care of, keep in good condition and use exclusively for matters related to my work activity. In case of loss, damage or misuse, I am responsible for paying the cost of repair or replacement of the equipment.',
    },
    receive: 'Receive',
    out: {
      title: 'Entries and Exits',
      date: 'Request date',
      outDate: 'Exit date',
      max_time: 'Maximum Days Out',
      outDays: 'Days Out',
      isOut: {
        title: 'Status',
        outside: 'Out',
        indoors: 'In',
        onHold: 'Awaiting authorization',
      },
      employee: 'Responsible',
      user_request: 'Requested by',
      user_authorized: 'Authorized by',
      message: 'Message',
    },
  },
  info: {
    tooltip: {
      asset_module: {
        sum_of_amounts_and_records:
          'The amounts calculated are based on the exchange rate recorded for each asset. If the exchange rate is not assigned, a default value of 1 will be used.',
      },
    },
  },
};



// WEBPACK FOOTER //
// src/locales/en.js